import { FC, useContext, MouseEvent } from "react";
import { Link } from "react-router-dom";

import { AuthContext } from "src/context/authContext";
// import { LoaderContext } from "src/context/loaderContext";
import useFetch from "src/hooks/useFetch";

import { AppLogo, AppLogoLight } from "src/assets";
import { redirectPath } from "src/constants";
import { AuthenticatedHCPHeader, AuthenticatedManufactureHeader } from "src/constants/headerLinks";

import { APIEndpoints } from "src/types/apiTypes";
import { LogoutAPISuccessResponseType } from "./types";

import MainNav from "./mainNav";
import UserDropdown from "./userDropdown";



const AuthHeader: FC = (): JSX.Element => {
  // const navigate = useNavigate();
  const { userData, isManufacturer, isUserAuthorized, destroySession } = useContext(AuthContext);
  // const { setLoader, hideLoader } = useContext(LoaderContext);
  const isSingleSignOn = localStorage.getItem("fromSingleSignOn")



  const { mutate } = useFetch<LogoutAPISuccessResponseType>(APIEndpoints.USER_LOGOUT);

  // useEffect(() => {
  //   if (data || error) {
  //     hideLoader();
  //     destroySession();
  //     const redirect_url = process.env.REACT_APP_PUBLIC_REDIRECT_URL
  //     console.log("in logout useEffect, about to be redirected to portal login")
  //     window.location.replace(redirect_url || "")
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [data, error]);

  const logoutUser = (e: MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    // if ((error && error.length > 0) || data) removeErrorAndData();

    // setLoader();
    mutate();
    destroySession();

    const redirect_url = process.env.REACT_APP_PUBLIC_REDIRECT_URL
    window.location.replace(redirect_url || "")
  };




  return (
    <nav className="navbar navbar-expand-lg p-3 pt-2 pb-2 auth-nav" style={{ backgroundColor: isUserAuthorized ? "#49176d" : "#FFF",}}>
      <Link className="navbar-brand" to={isUserAuthorized ?
          (userData?.is_password_changed ?
            (isManufacturer ? (userData ? redirectPath(userData) : "") : `/cases`) :
            '/users/createuser'
          ) :
          `/users/sign_in`
        }
      >
        <img className="img-fluid after-login-logo" src={isUserAuthorized ? AppLogoLight : AppLogo} alt="Site logo"/>
      </Link>
      <button className="navbar-toggler btn-outline-secondary" type="button" data-bs-toggle="collapse" data-bs-target="#authHeader">
        <span className="navbar-toggler-icon"></span>
      </button>
      <div className="collapse navbar-collapse" id="authHeader">
        <ul className="navbar-nav me-auto first-nav">
          {isSingleSignOn ? (
            isManufacturer === true ?
              AuthenticatedManufactureHeader.map((headerLink, index) => (
                <MainNav headerLink={headerLink} key={index} />
              ))
              :
              AuthenticatedHCPHeader.map((headerLink, index) => (
                <MainNav headerLink={headerLink} key={index} />
              ))
            ) 
            :
            userData?.is_password_changed ? (
              isManufacturer === true ?
                AuthenticatedManufactureHeader.map((headerLink, index) => (
                  <MainNav headerLink={headerLink} key={index} />
                ))
                :
                AuthenticatedHCPHeader.map((headerLink, index) => (
                  <MainNav headerLink={headerLink} key={index} />
                ))
            ) : null}
        </ul>
        <div className="text-start text-lg-end">
          <ul className="navbar-nav justify-content-start align-items-md-center">
            {
              isSingleSignOn ?
                <UserDropdown />
              :
                userData?.is_password_changed ?
                  <UserDropdown />    
                : (
                  <li className="nav-item dropdown">
                    <a
                      className="nav-link dropdown-toggle" href="." data-bs-toggle="dropdown"
                      aria-expanded="false" role="button"
                    >
                      {userData?.name}
                    </a>
                    <ul className="dropdown-menu dropdown-menu-end">
                      <li><a className="dropdown-item text-black" href="." onClick={logoutUser}>Logout</a></li>
                    </ul>
                  </li>
                )
            }
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default AuthHeader;
